var map = {
	"./common/apk_file_btn.png": 3759,
	"./common/app_store_btn.png": 4465,
	"./common/give_iocn.png": 2250,
	"./common/google_play_btn.png": 4236,
	"./common/history_fail_icon.png": 8966,
	"./common/history_gift_icon.png": 5258,
	"./common/history_recalled_icon.png": 5576,
	"./common/history_recalling_icon.png": 4506,
	"./common/history_success_icon.png": 114,
	"./common/home_banner_icon.png": 7137,
	"./common/home_give_icon.png": 5158,
	"./common/home_history_icon.png": 3370,
	"./common/home_scan_icon.png": 5629,
	"./common/img_upload.png": 3058,
	"./common/login_google_icon.png": 317,
	"./common/login_icon.png": 610,
	"./common/login_wechat_icon.png": 3862,
	"./common/logo_orientica.png": 4293,
	"./common/logo_orientica_o.png": 2038,
	"./common/member_default.png": 7551,
	"./common/navbar_scan.svg": 2503,
	"./common/portrait_icon.png": 8645,
	"./common/texture2.png": 452,
	"./en_US/Authen_Success.png": 4524,
	"./en_US/Recalled.png": 3222,
	"./ja_JP/Authen_Success.png": 6853,
	"./ja_JP/Recalled.png": 990,
	"./zh_CN/Authen_Success.png": 9339,
	"./zh_CN/Recalled.png": 65,
	"./zh_TW/Authen_Success.png": 6125,
	"./zh_TW/Recalled.png": 9962,
	"images/orientica/common/apk_file_btn.png": 3759,
	"images/orientica/common/app_store_btn.png": 4465,
	"images/orientica/common/give_iocn.png": 2250,
	"images/orientica/common/google_play_btn.png": 4236,
	"images/orientica/common/history_fail_icon.png": 8966,
	"images/orientica/common/history_gift_icon.png": 5258,
	"images/orientica/common/history_recalled_icon.png": 5576,
	"images/orientica/common/history_recalling_icon.png": 4506,
	"images/orientica/common/history_success_icon.png": 114,
	"images/orientica/common/home_banner_icon.png": 7137,
	"images/orientica/common/home_give_icon.png": 5158,
	"images/orientica/common/home_history_icon.png": 3370,
	"images/orientica/common/home_scan_icon.png": 5629,
	"images/orientica/common/img_upload.png": 3058,
	"images/orientica/common/login_google_icon.png": 317,
	"images/orientica/common/login_icon.png": 610,
	"images/orientica/common/login_wechat_icon.png": 3862,
	"images/orientica/common/logo_orientica.png": 4293,
	"images/orientica/common/logo_orientica_o.png": 2038,
	"images/orientica/common/member_default.png": 7551,
	"images/orientica/common/navbar_scan.svg": 2503,
	"images/orientica/common/portrait_icon.png": 8645,
	"images/orientica/common/texture2.png": 452,
	"images/orientica/en_US/Authen_Success.png": 4524,
	"images/orientica/en_US/Recalled.png": 3222,
	"images/orientica/ja_JP/Authen_Success.png": 6853,
	"images/orientica/ja_JP/Recalled.png": 990,
	"images/orientica/zh_CN/Authen_Success.png": 9339,
	"images/orientica/zh_CN/Recalled.png": 65,
	"images/orientica/zh_TW/Authen_Success.png": 6125,
	"images/orientica/zh_TW/Recalled.png": 9962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8230;